import { Metadata, descriptorOf } from '@tencent/workbench-core';
import { InjectorService } from '../classes/injector-service.js';

// TODO: 重构 inject，解决 ts 报错问题
/**
 * 类成员变量装饰器，用于向类成员注入一个 Provider
 *
 * @remarks
 * ### Example
 *
 * ```typescript
 * import { Inject, EventEmitter } from '@tencent/workbench';
 *
 * class MyClass {
 *   @Inject()
 *   eventEmitter: EventEmitter;
 *
 *   method() {
 *     this.eventEmitter.emit('$doSomething');
 *   }
 * }
 * ```
 *
 * @param symbol - 被注入对象在容器中的标识
 *
 * @public
 */
// export function Inject(symbol?: RegistryKey): PropertyDecorator;
// export function Inject(symbol?: RegistryKey): MethodDecorator;
// export function Inject(symbol?: RegistryKey): ParameterDecorator;
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function Inject(symbol) {
    return function (target, targetKey, descriptor) {
        if (typeof descriptor === 'number') {
            if (symbol) {
                const paramTypes = Metadata.getParamTypes(target, targetKey);
                paramTypes[descriptor] = symbol;
                Metadata.setParamTypes(target, targetKey, paramTypes);
            }
        }
        else {
            if (descriptor === undefined) {
                descriptor = descriptorOf(target, targetKey);
            }
            if (descriptor === undefined) {
                // 对类的成员进行注入
                if (symbol) {
                    Metadata.setType(target, targetKey, symbol);
                }
                return {
                    get: () => InjectorService.invokeGetter(target, targetKey),
                };
            }
            // 通过这种方式保存对原始方法的引用，我们将当前值保留在描述符中
            // 这样不会覆盖其他装饰器可能对描述符所做的操作。
            const originalMethod = descriptor.value;
            descriptor.value = function (locals = new Map()) {
                if (locals instanceof Map === false) {
                    locals = new Map();
                }
                return InjectorService.invokeMethod(originalMethod.bind(this), {
                    target,
                    methodName: targetKey,
                    locals,
                });
            };
            descriptor.value.$injected = true;
            return descriptor;
        }
    };
}

export { Inject };
//# sourceMappingURL=inject.js.map
